// extracted by mini-css-extract-plugin
export default {"button":"iconButton_button__vlepS"};